import React, { useEffect, useState } from "react";
import { Handshake, Loader2, RefreshCw } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { AssociateRow } from "@/components/admin/AssociatesPanel";

// Lot 758 — console d'un associé › Finances › Associés : SA carte d'associé (la même que celle du super admin, en lecture
// seule : aucun bouton Modifier / Verser / Retirer). Les autres associés ne sont jamais listés. Toute modification faite
// par le super admin (part, versement) se reflète ici aussitôt (même données, `GET /admin/associates/me`).
export const MyAssociatePanel = () => {
  const [d, setD] = useState(null);
  const [loading, setLoading] = useState(true);
  const load = () => { setLoading(true); api.get("/admin/associates/me").then(({ data }) => setD(data)).catch(() => setD(false)).finally(() => setLoading(false)); };
  useEffect(() => { load(); }, []);
  const cur = d?.currency || "EUR";
  return (
    <div className="space-y-4" data-testid="my-associate-panel">
      <div className="flex items-center gap-2 flex-wrap">
        <div className="h-10 w-10 rounded-xl grid place-items-center" style={{ background: "var(--yalola-primary-soft)", color: "var(--yalola-primary)" }}><Handshake size={20} /></div>
        <div>
          <h2 className="text-lg font-extrabold font-display">Ma carte d'associé</h2>
          <p className="text-xs" style={{ color: "var(--yalola-text-muted)" }}>Ta part du revenu net de la plateforme (après frais, TVA stores, dépenses et remboursements), tes gains potentiels mois par mois, les versements reçus et le solde. Les versements sont enregistrés par le super admin.</p>
        </div>
        <Button size="sm" variant="outline" className="rounded-full ml-auto" onClick={load} disabled={loading} data-testid="my-associate-refresh">{loading ? <Loader2 size={14} className="animate-spin" /> : <RefreshCw size={14} />}</Button>
      </div>
      {d === false && <p className="text-sm" style={{ color: "#B91C1C" }} data-testid="my-associate-error">Chargement impossible.</p>}
      {d && !d.me && (
        <div className="yalola-card p-6 text-center text-sm" style={{ color: "var(--yalola-text-muted)" }} data-testid="my-associate-empty">Aucune carte d'associé n'est rattachée à ton compte pour le moment.</div>
      )}
      {d?.me && <AssociateRow a={d.me} currency={cur} readOnly />}
      {d?.me && d.me.status !== "active" && <p className="text-xs" style={{ color: "var(--yalola-text-muted)" }} data-testid="my-associate-former">Part terminée le {String(d.me.removed_at || "").slice(0, 10)} — le solde restant reste visible jusqu'à son versement.</p>}
    </div>
  );
};

export default MyAssociatePanel;
